import styled from 'react-emotion'

export const Container = styled.div`
  display: ${p => (p.showOnScreen ? 'block' : 'none')};

  @media print {
    display: ${p => (p.showOnPrint ? 'block' : 'none')};
  }
`
